export function Window({ isDark, isSlider, style, children }) {
    return (
        <div
            className={
                isSlider ? 'window-slider' : isDark ? 'window-dark' : 'window'
            }
            style={style}
        >
            {children}
        </div>
    );
}
